module.exports = "/*\nsection.view {\n  height: calc(100vh - 50px);\n}\n*/\n"